import { render } from "./mainComponent.vue?vue&type=template&id=3571819d&scoped=true"
import script from "./mainComponent.vue?vue&type=script&lang=js"
export * from "./mainComponent.vue?vue&type=script&lang=js"

import "./mainComponent.vue?vue&type=style&index=0&id=3571819d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3571819d"]])

export default __exports__